import { connect } from 'react-redux';

import { closeLightbox, openLightbox, toggleBasemap } from '../actions';
import App from '../components/App';

const mapStateToProps = ({ browser, lightbox, mapLayers }) => {
  const { height, width } = browser;
  const { isOpen } = lightbox;
  const { basemap } = mapLayers;
  return {
    appHeight: height,
    appWidth: width,
    basemap,
    isOpen,
    referrer: lightbox.referrer,
    payload: lightbox.payload,
  };
};

export default connect(mapStateToProps, {
  closeLightbox,
  openLightbox,
  toggleBasemap,
})(App);



// WEBPACK FOOTER //
// ./src/containers/AppConnected.jsx